import { Tab, Tabs, Typography } from '@mui/material';
import { JSX, useCallback } from 'react';

import { VeranstaltungHealthIcon } from '../../components/general/HealthIcon/VeranstaltungHealthIcon.tsx';
import { AkaVeranstaltungId, sapStatus } from '../../dtos.ts';
import { elevateColorPalette } from '../../theme/colorPalette.ts';
import { Modultermin } from './DurchgangDetailsPage.types.ts';

type DurchgangOverviewTabBarProps = {
  modultermine: Modultermin[];
  akaVeranstaltungId?: AkaVeranstaltungId | null;
  onTabChange: (akaVeranstaltungId: AkaVeranstaltungId | null) => void;
};

export const DurchgangOverviewTabBar = ({
  modultermine,
  akaVeranstaltungId,
  onTabChange,
}: DurchgangOverviewTabBarProps) => {
  const handleChange = useCallback(
    (_: unknown, value: AkaVeranstaltungId | null) => {
      onTabChange(value);
    },
    [onTabChange],
  );

  return (
    <Tabs
      slotProps={{ indicator: { style: { display: 'none' } } }}
      variant="scrollable"
      scrollButtons="auto"
      aria-label="scrollable auto tabs"
      value={akaVeranstaltungId}
      onChange={handleChange}
    >
      <Tab key="overview" value={null} label="Übersicht" sx={tabStyle} />
      {modultermine.map((modultermin, idx) => (
        <Tab
          key={idx + 1}
          value={modultermin.akaVeranstaltungId}
          label={getLabelByModultermin(modultermin)}
          sx={tabStyle}
        />
      ))}
    </Tabs>
  );
};

const tabStyle = {
  fontWeight: 500,
  borderRadius: '8px',
  '&.Mui-selected': {
    borderColor: elevateColorPalette.surface.brandDark,
    backgroundColor: elevateColorPalette.surface.brandDark,
    color: elevateColorPalette.text.primaryOnBrand,
    borderWidth: '2px',
    borderStyle: 'solid',
    padding: '8px 12px',
  },
  '& .foo': {
    color: elevateColorPalette.text.primary,
  },
  '&.Mui-selected .labelWithIcon': {
    color: elevateColorPalette.text.primaryOnBrand,
  },
};

function getLabelByModultermin({
  sapStatus: sapStatusFromTermin,
  akaVeranstaltungId,
  modul,
}: Modultermin): JSX.Element | string {
  const modulnummer = modul.modulnummer;
  if (sapStatusFromTermin === sapStatus.ABGESAGT) {
    return (
      <span>
        <s>Modul {modulnummer}</s> (abgesagt)
      </span>
    );
  } else {
    return (
      <Typography className="labelWithIcon" variant="paragraph" display="inline-flex" alignItems="center" gap={1}>
        Modul {modulnummer}
        <VeranstaltungHealthIcon akaVeranstaltungId={akaVeranstaltungId} hideSuccessIcon={true} />
      </Typography>
    );
  }
}
